// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"43c1c65d","261":"b07f4454","287":"834a0573","326":"3bfaa355","327":"61a51ec8","787":"4450c8af","855":"063f17b2","894":"56cb2327"}[chunkId] + ".chunk.js";
};